import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export abstract class GenericDtoAssemblerService<Entity, Dto> {
  public abstract toDto(entity: Entity): Dto | Promise<Dto>;

  public abstract fromDto(dto: Dto): Entity | Promise<Entity>;

  public toDtoList(entities: Entity[]): (Promise<Dto> | Dto)[] {
    return entities.map((entity) => this.toDto(entity));
  }

  public fromDtoList(dtos: Dto[]): (Promise<Entity> | Entity)[] {
    return dtos.map((dto) => this.fromDto(dto));
  }
}
